/*eslint-disable @typescript-eslint/ban-types*/
/*eslint-disable  @typescript-eslint/no-unused-vars*/
import React from 'react';
import './AdvanceRuleEngineGrid.css';
import { IAdvanceRuleEngineListItem } from '../../rmsReduxStore/advanceRuleEngineRedux/advanceRuleEngineType';
import { Box, ThemeProvider, Typography } from '@mui/material';
import { PaginationTheme } from '../../globalUtils/globalExports';
import { Pagination, TotalCountComponent } from '../../globalUtils/TableDashboard/TablePagination';
import { formatNumberWithCommas } from '../../globalUtils/globalHooks';
import TablePageCount from '../../globalUtils/TableDashboard/TablePageCount';
import AdvanceRuleEngineGridCard from './AdvanceRuleEngineGridCard';
import InfoIcon from '@mui/icons-material/Info';


interface IAdvanceRuleEngineGrid{
    list: IAdvanceRuleEngineListItem[],
    layoutCallback: ()=>void,
    handleDeleteRule: Function,
    totalCount: number,
    totalCountText: string,
    pageNumber: number,
    tablePageSize: number,
    handlePageSizeChange: (count: number) => void,
    handlePageNumberChange: (page: number) => void

}

const AdvanceRuleEngineGrid: React.FC<IAdvanceRuleEngineGrid> = (props) => {
  const {list,layoutCallback,totalCount,totalCountText,pageNumber,tablePageSize,handlePageSizeChange,handlePageNumberChange,handleDeleteRule} = props;


  return (
    <div className='advance__rule__engine__grid__container'>
        <div className='advance__rule__engine__grid__cards-container'>
            {
                list && list.length > 0  ? <div className='advance__rule__engine__grid__cards'>
                    {
                        list.map((rule)=> {
                            return (
                                <AdvanceRuleEngineGridCard 
                                 key={rule?.id}
                                 rule={rule}
                                 fetchRules={layoutCallback}
                                 handleDeleteRule={handleDeleteRule}
                                />
                            )
                        })
                    }
                </div>
                :
                <Box
                    display="flex"
                    flexDirection="column"
                    alignItems="center"
                    justifyContent="center"
                    height="50vh"
                    textAlign="center"
                    margin="auto"
                >
                    <InfoIcon sx={{ fontSize: 48, color: 'gray' }} />
                    <Typography variant="h6" sx={{ color: 'gray', mt: 2 }}>
                        No Rules Available
                    </Typography>
                </Box>
            }
        </div>
        <div className='grid_card_pagination_footer'>
            <ThemeProvider theme={PaginationTheme}>
                <div className='table__footer__wrap-paginated-grid'>
                    <div className='table__footer__wrap-paginated-grid-right'>
                        <TotalCountComponent
                            totalCount={formatNumberWithCommas(totalCount)}
                            totalCountText={totalCountText}
                        />
                    </div>
                    <div className='table__footer__wrap-paginated-grid-right'>
                        <TablePageCount onCountChange={(pageSize) => handlePageSizeChange(pageSize)}/>
                        <Pagination
                            count={Math.ceil(totalCount ? totalCount / (tablePageSize ?? 1) : 1)}
                            onPageChange={(event, pageNumber) => handlePageNumberChange(pageNumber)}
                            rowsPerPage={tablePageSize ?? 5}
                            page={pageNumber ?? 1}
                        />
                    </div>
                </div>
            </ThemeProvider>
        </div>
    </div>
  )
}

export default AdvanceRuleEngineGrid;